export default {
  data() {
    return {
      localizedGoals: [
        {
          key: "Reduce medication dependency",
          value: "message.goalReduceMedication"
        },
        {
          key: "reduced your medication",
          value: "message.goalReducedMedication"
        },
        {
          key: "Lose weight",
          value: "message.goalLoseWeight"
        },
        {
          key: "lost weight",
          value: "message.goalLostWeight"
        },
        {
          key: "Reduce blood glucose/HbA1c",
          value: "message.goalReduceBloodGlucose"
        },
        {
          key: "improved blood glucose control",
          value: "message.goalReducedBloodGlucose"
        },
        {
          key: 'Healthy lifestyle for me and my family',
          value: "message.goalHealthyLifestyle"
        },
        {
          key: "improved the health of your family",
          value: "message.goalImprovedHealth"
        },
        {
          key: "Sense of wellbeing",
          value: "message.goalSenseOfWellbeing"
        },
        {
          key: "achieved a greater sense of wellbeing",
          value: "message.goalImprovedSenseOfWellbeing"
        },
        {
          key: "Something else",
          value: "message.goalSomethingElse"
        },
        {
          key: "accomplished your other goal",
          value: "message.goalImprovedSomethingElse"
        }
      ]
    }
  },
  methods: {
    localizeGoal(key) {
      let self = this;
      let localizedGoal = self.localizedGoals.filter(function (item) {
        return item.key === key;
      });
      if(localizedGoal.length === 1) {
        return self.$t(localizedGoal[0].value)
      }
      else {
        return key;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Localization/Goals/index.js